module.exports = __webpack_public_path__ + "static/media/PTM55FT.75758927.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PTM55FT.ttf
// module id = 594
// module chunks = 0